module.exports = __webpack_public_path__ + "static/media/unm-01.04f1aabc.png";